import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_ASSESSMENT_TEMPLATE_SECTION, GET_ASSESSMENT_TEMPLATE_SECTION_BY_TEMPLATE_ID } from "../../utils/routes";

// ---------------------------------------------------------------------

export const createAssessmentTemplateSection = createAsyncThunk(
  "assessmentTemplateSection/createAssessmentTemplateSection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_ASSESSMENT_TEMPLATE_SECTION, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getAssessmentTemplateSection = createAsyncThunk(
  "assessmentTemplateSection/getAssessmentTemplateSection",
  async (data, {rejectWithValue}) => {
    try {
      const response = await axios.post(GET_ASSESSMENT_TEMPLATE_SECTION_BY_TEMPLATE_ID, data, { withCredentials: true });
      return response
    } catch (err) {
      return rejectWithValue(err.response)
    }
  }
);

export const updateAssessmentTemplateSection = createAsyncThunk(
  "assessmentTemplateSection/updateAssessmentTemplateSection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_ASSESSMENT_TEMPLATE_SECTION, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteAssessmentTemplateSection = createAsyncThunk(
  "assessmentTemplateSection/deleteAssessmentTemplateSection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_ASSESSMENT_TEMPLATE_SECTION, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const assessmentTemplateSectionSlice = createSlice({
  name: "assessmentTemplateSection",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    assessmentTemplateSectionData: [],
    selectedData: {},
    selectedSectionData :{}
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
    sectionRowSelect: (state, action) => {
      state.selectedSectionData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createAssessmentTemplateSection.pending]: (state, action) => {
      state.loading = true;
    },
    [createAssessmentTemplateSection.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createAssessmentTemplateSection.rejected]: (state, action) => {
      console.log( action?.payload?.message)
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getAssessmentTemplateSection.pending]: (state, action) => {
      state.loading = true;
    },
    [getAssessmentTemplateSection.fulfilled]: (state, action) => {
      state.loading = false;
      state.assessmentTemplateSectionData = action?.payload?.data;
    },
    [getAssessmentTemplateSection.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateAssessmentTemplateSection.pending]: (state, action) => {
      state.loading = true;
    },
    [updateAssessmentTemplateSection.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateAssessmentTemplateSection.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteAssessmentTemplateSection.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteAssessmentTemplateSection.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteAssessmentTemplateSection.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect,sectionRowSelect } =
  assessmentTemplateSectionSlice.actions;
export default assessmentTemplateSectionSlice.reducer;
